/** Shared game-config option lists (formats, divisions, gender splits). */

export const FORMATS = ["Outdoor", "Beach", "Indoor"];
export const GENDERS = ["Open", "Women", "Mixed"];

// Gender splits per format. The split changes per point in Mixed, so this
// list is shown on the sequence (labeling) step, not at video upload.
export const SPLITS_BY_FORMAT = {
  Outdoor: [
    { value: "4M/3W", label: "4M / 3W" },
    { value: "3M/4W", label: "3M / 4W" },
    { value: "5M/2W", label: "5M / 2W · Soft Mixed" },
    { value: "2M/5W", label: "2M / 5W · Soft Mixed" },
  ],
  Beach: [
    { value: "3M/2W", label: "3M / 2W" },
    { value: "2M/3W", label: "2M / 3W" },
    { value: "4M/1W", label: "4M / 1W · Soft Mixed" },
    { value: "1M/4W", label: "1M / 4W · Soft Mixed" },
  ],
  Indoor: [
    { value: "3M/2W", label: "3M / 2W" },
    { value: "2M/3W", label: "2M / 3W" },
    { value: "4M/1W", label: "4M / 1W · Soft Mixed" },
    { value: "1M/4W", label: "1M / 4W · Soft Mixed" },
  ],
};

export const FIELD_DIMS = {
  Outdoor: { full: [100, 37], endzone: [18, 37] },
  Beach: { full: [75, 25], endzone: [10, 25] },
  Indoor: { full: [50, 25], endzone: [5, 25] },
};
